import React from 'react';
import { Route, Routes } from 'react-router-dom';
import OrganisationDetails from '../../../../mgmt/organisations/components/OrganisationDetails';
import PrincipalDetail from '../../../../mgmt/organisations/components/principals/PrincipalDetail';

const OrganisationScene = () => (
  <Routes>
    <Route
      path="users/details/:actionId?/:tab?/:action?"
      element={<PrincipalDetail menuName="users" />}
    />
    <Route
      path=":tab?/:action?/:actionId?"
      element={<OrganisationDetails menuName="users" />}
    />
  </Routes>
);

export default OrganisationScene;
